"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowButton = exports.SmallCarousel = exports.LargeCarousel = exports.Carousel = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.map");

var _palette = require("@artsy/palette");

var _react = _interopRequireDefault(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Responsive = require("../../Utils/Responsive");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    .slick-list {\n      padding: 0 !important;\n      height: ", "px;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel() {
    _classCallCheck(this, Carousel);

    return _possibleConstructorReturn(this, _getPrototypeOf(Carousel).apply(this, arguments));
  }

  _createClass(Carousel, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Responsive.Media, {
        at: "xs"
      }, _react.default.createElement(SmallCarousel, this.props)), _react.default.createElement(_Responsive.Media, {
        greaterThan: "xs"
      }, _react.default.createElement(LargeCarousel, this.props)));
    }
  }]);

  return Carousel;
}(_react.default.Component);

exports.Carousel = Carousel;

_defineProperty(Carousel, "defaultProps", {
  height: 300
});

var LargeCarousel = function LargeCarousel(props) {
  var slickConfig = _objectSpread({
    arrows: false,
    draggable: false,
    infinite: false,
    speed: 500,
    variableWidth: true,
    slidesToScroll: 5
  }, props.settings);

  var slickRef = null;

  var LeftArrow = function LeftArrow() {
    return _react.default.createElement(ArrowButton, {
      left: -8,
      onClick: function onClick() {
        slickRef.slickPrev && slickRef.slickPrev(); // check existence for tests

        props.onArrowClick && props.onArrowClick();
      }
    }, _react.default.createElement(_palette.ChevronIcon, {
      direction: "left",
      fill: "black100",
      width: 30,
      height: 30
    }));
  };

  var RightArrow = function RightArrow() {
    return _react.default.createElement(ArrowButton, {
      right: -8,
      onClick: function onClick() {
        slickRef.slickNext && slickRef.slickNext(); // check existence for tests

        props.onArrowClick && props.onArrowClick();
      }
    }, _react.default.createElement(_palette.ChevronIcon, {
      direction: "right",
      fill: "black100",
      width: 30,
      height: 30
    }));
  };

  return _react.default.createElement(_palette.Flex, {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    height: props.height
  }, props.renderLeftArrow ? props.renderLeftArrow(_objectSpread({
    Arrow: LeftArrow,
    getSlick: function getSlick() {
      return slickRef;
    }
  }, props)) : _react.default.createElement(LeftArrow, null), _react.default.createElement(CarouselContainer, {
    height: props.height
  }, _react.default.createElement(_reactSlick.default, _extends({}, slickConfig, {
    ref: function ref(slider) {
      return slickRef = slider;
    }
  }), props.data.map(function (slide, index) {
    return _react.default.createElement(_palette.Box, {
      key: index
    }, props.render(slide));
  }))), props.renderRightArrow ? props.renderRightArrow(_objectSpread({
    Arrow: RightArrow,
    getSlick: function getSlick() {
      return slickRef;
    }
  }, props)) : _react.default.createElement(RightArrow, null));
};

exports.LargeCarousel = LargeCarousel;

var SmallCarousel = function SmallCarousel(props) {
  var slickConfig = _objectSpread({
    arrows: false,
    dots: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    touchThreshold: 60,
    variableWidth: true
  }, props.settings);

  return _react.default.createElement(_palette.Flex, {
    justifyContent: "space-around",
    alignItems: "center"
  }, _react.default.createElement(CarouselContainer, {
    height: props.height
  }, _react.default.createElement(_reactSlick.default, slickConfig, props.data.map(function (slide, index) {
    return _react.default.createElement(_palette.Box, {
      key: index
    }, props.render(slide));
  }))));
};

exports.SmallCarousel = SmallCarousel;

var CarouselContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__CarouselContainer",
  componentId: "sc-1swuwer-0"
})(["width:100%;", ";", ";", ";.slick-track{display:inline-flex;width:100% !important;}.slick-slide{position:relative;top:-18px;}", ";", ";.slick-dots li{width:0;button{&::before{font-size:4px;}}}"], ""
/*
FIXME: Revisit using react-slick -- too many hacks
*/
, function (props) {
  if (props.height) {
    return "\n        height: ".concat(props.height, "px;\n\n        .slick-slider, .slick-list, .slick-slide {\n          height: ").concat(props.height, "px;\n        }\n      ");
  }
}, ""
/*
FIXME: The below two rules are hacks for SSR to render properly.
Might have been fixed in https://github.com/artsy/reaction/pull/929
*/
, ""
/*
FIXME: On SSR mobile this shifts the image, must fix
Might be fixed in https://github.com/artsy/reaction/pull/929
*/
, _palette.media.xs(_templateObject(), function (p) {
  return p.height;
}));

var ArrowButton = (0, _styledComponents.default)(_palette.Flex).withConfig({
  displayName: "Carousel__ArrowButton",
  componentId: "sc-1swuwer-1"
})(["position:relative;cursor:pointer;display:flex;align-items:center;user-select:none;opacity:0.1;transition:opacity 0.25s;min-height:", "px;&:hover{opacity:1;}", ";", ";"], function (p) {
  return p.height || 200;
}, _styledSystem.left, _styledSystem.right);
exports.ArrowButton = ArrowButton;
//# sourceMappingURL=Carousel.js.map